module.exports = "<p>\n  editnews works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/app/components/pages/news/editnews/editnews.component.html
// module id = ../../../../../src/app/components/pages/news/editnews/editnews.component.html
// module chunks = main